export default __webpack_public_path__ + "pgnv-assets/6b4a33ededac0360ec5d3c25d97a65f3.png";